<template>
  <b-card no-header no-footer>
    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <template
              v-for="(m, index) in filterModel([
                'code',
                'name',
              ])"
            >
              <div :key="'kode_rekening_' + index">
                <form-group-input
                  :ref="index"
                  :type="m.type"
                  :label="typeof m.label === 'string' ? m.label : null"
                  :options="
                    m.type === 'radio'
                      ? getClassicOptions(index)
                      : getOptions(index)
                  "
                  :need-label="true"
                  v-model="m.value"
                  :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                  :disabled="
                    typeof m.disabled !== 'undefined' ? m.disabled : null
                  "
                  :id="index"
                />
              </div>
            </template>
          </b-col>
        </b-row>
        <div>
          <b-button type="submit" variant="primary" class="mt-0"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Simpan</b-button
          >
          <b-button
            :to="'/kode-rekening'"
            variant="secondary"
            class="ml-3 float-right"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Batal</b-button
          >
        </div>
      </form>
    </ValidationObserver>
  </b-card>
</template>

<script>
import {
  saveProcess,
  setModelValue,
  scrollToError,
  objectToOptions,
  classicObjectToOptions,
} from "@/_helpers";
import formGroupInput from "@/components/FormGroupInput.vue";
import Rekening from "@/models/Rekening.js";

const rekeningModel = new Rekening();

export default {
  components: {
    formGroupInput,
  },
  watch: {
    "$route.params.id": function (val) {
      if (this.mode === "update") {
        this.getDetail();
      }
    },
    totalPromiseAreaCount: async function (val) {
      if (val >= 4) {
        this.initEdit = false;
      }
    },
  },
  computed: {
    mode: function () {
      return this.$route.params.id !== undefined ? "update" : "create";
    },
  },
  data() {
    return {
      totalPromiseAreaCount: 0,
      initEdit: false,
      isLoading: false,
      rekeningModel: rekeningModel.init(),
    };
  },
  mounted() {
    if (this.mode === "update") {
      this.getDetail();
    }

    // this.getParentAccountCodes();
  },
  methods: {
    async getParentAccountCodes () {
      return new Promise(resolve => {
        rekeningModel.list({
          'parent_only': 1,
          'list_items': 1,
          'limit': 200
        }).then(resp => {
          let data = []
          resp.data.forEach(d => {
            data[d.id] = d.name
          })

          this.rekeningModel.parent_id.options = data
        })
      })
    },
    filterModel(search) {
      const filtered = Object.entries(this.rekeningModel).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    getOptions(key) {
      return typeof this.rekeningModel[key].options !== "undefined"
        ? objectToOptions(this.rekeningModel[key].options)
        : null;
    },
    getClassicOptions(key) {
      return typeof this.rekeningModel[key].options !== "undefined"
        ? classicObjectToOptions(this.rekeningModel[key].options)
        : null;
    },
    getDetail() {
      this.initEdit = true;
      this.isLoading = true;
      rekeningModel
        .find(this.$route.params.id, {
          detail: 1,
        })
        .then((resp) => {
          this.isLoading = false;
          Object.keys(this.rekeningModel).forEach((key) => {
            if (typeof this.$refs[key] !== "undefined") {
              this.$refs[key][0].setValue(resp[key]);
            }else {
              key === 'password' ? this.$refs["admin_" + key][0].setValue('') : this.$refs["admin_" + key][0].setValue(resp['admin'][key])
            }
          });
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== "production") {
            console.error(error);
          }
          this.isLoading = false;
        });
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success || this.isLoading) {
          scrollToError(this.$refs.form);
          return false;
        }
        saveProcess(this.rekeningModel, this.mode === "update")
          .then((model) => {
            this.isLoading = true;
            if (this.mode === "update") {
              rekeningModel
                .update(this.$route.params.id, model)
                .then(() => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data kode rekening berhasil diubah."
                  );
                  this.$router.push("/kode-rekening/" + this.$route.params.id);
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            } else {
              rekeningModel
                .create(model)
                .then((resp) => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data user berhasil disimpan."
                  );
                  this.$router.push("/kode-rekening/" + resp.id);
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            }
          })
          .catch(() => {});
      });
    },
  },
};
</script>